<template>
    <div class="publication__success content-width">
        <div class="publication__success-block">
            <div class="publication__success-content d-flex">
                <div class="publication__success-title">{{ text }}</div>
            </div>
        </div>
        <div class="publication__success-action d-flex" v-if="btnText && btnUrl">
            <a class="btn publication__btn publication__btn--primary" :href="btnUrl" >{{ btnText }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubmitSuccess",
    props: {
        text: {
            type: String,
            required: true
        },
        btnText: {
            type: String,
            default: null
        },
        btnUrl: {
            type: String,
            default: null
        }
    }
}
</script>
